module.exports = __webpack_public_path__ + "img/wallet.3b429a14.svg";